module.exports = __webpack_public_path__ + "img/m_bg1.c4a47884.png";